export default {
    'general': {
        'versioning': 'Versioning',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'unknown': 'Unknown',
        'latest_version': 'Latest version',
        'change': 'Change',
        'unlimited': 'Unlimited',
        'from': 'From',
        'to': 'To',
        'date': 'Date',
        'custom': 'Custom',
        'country': 'Country',
        'total': 'Total',
        'basic_data': 'Basic data',
        'show_more': 'Show more',
        'profile': 'Prifile',
        'export_data': 'Export data',
        'approve': 'Approve',
        'reject': 'Reject'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this username already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_publish': 'There was an error while publishing',
        'on_approve': 'There was an error while approving',
        'on_download': 'There was an error while downloading file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'username_exists': 'This username already exists. Please use different username.',
        'failed_to_insert': 'Failed to insert',
        'file_to_big': 'File is to big',
        'missing_roles': 'Missing roles',
        'no_roles_selected': 'User must have at least one role selected',
        'fetching_data': 'Error fetching data',
        'deleting_default_data': 'Error deleting default data',
        'data_already_exists': 'Data already exists',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'no_access': 'No access',
        'equipment_not_purchased': 'Not all equipment has been purchased',
        'role_exists': 'Role exists',
        'role_does_not_exist': 'role does not exists',
        'time_parser': {
            'invalid_character_error': 'Only numbers and {0} units are allowed.',
            'number': 'number',
            'unit': 'unit',
            'invalid_format_error': 'Units must be in form of',
            'duplicated_unit_error': 'The unit {0} is duplicated.',
            'example': '(example: 3d12h)'
        },
        'max_queue_time': 'Max time for queue excided. Please use shorter duration.',
        'queue_time_to_small': 'Queue time is to short. Use longer duration.',
        'tax_number_not_found': 'Tax number not found',
        'tax_number_country_not_specified': 'Country for tax number is not specified',
        'tax_number_invalid_data': 'Invalid data received for tax number'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_publish': 'Successfully published',
        'on_approve': 'Successfully approved',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'channel_package_activated': 'Channel package successfully activated',
        'channel_package_deactivated': 'Channel package successfully deactivated'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate',
        'publish': 'Are you sure you want to publish on',
        'approve': 'Are you sure you want to approve'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'language': {
        'slovenian': 'Slovenian',
        'english': 'English'
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password_text': 'If password field is empty, password will not be changed.',
        'change_password': 'Change password'
    },
    'role': {
        'role': 'Role | Roles',
        'admin': 'Administrator',
        'user': 'User'
    },
    'user': {
        'user': 'User | Users',
        'add': 'Add user',
        'edit': 'Edit user',
        'name': 'Name',
        'username': 'Username',
        'image': 'Image',
        'password': 'Password',
        'confirm_password': 'Confirm password',
        'cannot_edit_username': 'Username cannot be edited',
        'change_password': 'Change password',
        'new_password': 'New password'
    },
    'equipment': {
        'additional_equipment': 'Additional equipment | Additional equipments',
        'card_payment_equipment': 'Card payment equipment | Card payment equipments',
        'add_additional_equipment': 'Add additional equipment',
        'edit_additional_equipment': 'Edit additional equipment',
        'add_card_payment_equipment': 'Add card payment equipment',
        'edit_card_payment_equipment': 'Edit card payment equipment',
        'color': 'Color',
        'monthly_price': 'Monthly price',
        'one_time_price': 'One time price',
        'bought': 'Bought',
        'not_bought': 'Not bought',
        'provider_name': 'Provider name'
    },
    'current_program': {
        'current_program': 'Current program | Current programs',
        'add': 'Add current program',
        'edit': 'Edit current program',
        'color': 'Color'
    },
    'customer': {
        'customer': 'Customer | Customers',
        'add': 'Add customer',
        'edit': 'Edit customer',
        'alias': 'Alias',
        'tax_number': 'Tax number',
        'tax_payer': 'Tax payer',
        'address': 'Address',
        'current_program': 'Current program',
        'seller': 'Seller | Sellers',
        'date_of_visit_customer': 'Date of visit customer',
        'person_who_entering_data': 'Person who entering data',
        'date_by_which_data_must_be_entered': 'Date by which data must be entered',
        'installation_date': 'Installation date',
        'installation_service_technicians': 'Installation service technicians',
        'cash_register_license': 'Cash register license',
        'number_of_desktop_devices': 'Number of desktop devices',
        'number_of_mobile_devices': 'Number of mobile devices',
        'value_of_offer_to_customer': 'Value of offer to customer',
        'estimated_monthly_price': 'Estimated monthly price of equipment',
        'estimated_one_time_price': 'Estimated one time price of equipment',
        'contract_value': 'Contract value',
        'difference_between_offer_value_and_contract_value': 'Difference between offer value and contract value',
        'message': 'Message',
        'customers_without_added_users': 'Customers without added users',
        'move_to_sale': 'Move to sale',
        'view_customer': 'View customer',
        'enter_data': 'Enter data',
        'installation': 'Installation',
        'status': {
            'status': 'Status',
            'current_status': 'Current status',
            'change_status': 'Change status',
            'waiting': 'Waiting',
            'sale': 'Sale',
            'entering_data': 'Entering data',
            'installation': 'Installation',
            'completed': 'Completed'
        },
        'graph': {
            'number_of_clients_by_program': 'Number of clients by program',
            'number_of_customers_with_waiting_status': 'Number of customers with waiting status',
            'number_of_customers_waiting_for_equipment': 'Number of customers waiting for equipment',
            'number_of_customers_without_assigned_users': 'Number of without assigned users'
        },
        'price_list': 'Price list',
        'certificate': 'Certificate',
        'certificate_password': 'Certificate password',
        'list_of_employees': 'List of employees',
        'contract': 'Contract',
        'enter_text': 'Enter text'
    },
    'contact': {
        'contact': 'Contact',
        'phone_number': 'Phone number'
    },
    'cash_register': {
        'cash_register': 'Cash register',
        'mobile_cash_register': 'Mobile cash register',
        'cash_register_data': 'Cash register data',
        'essential': 'Essential',
        'standard': 'Standard',
        'premium': 'Premium',
        'reduced_essential': 'Reduced essential',
        'monthly_rental': 'Monthly rental',
        'calculations': 'Izračuni pogodb',
        'additional': 'Additional'
    },
    'besteron': {
        'payment_data': 'Besteron payment data',
        'company_name': 'Company name',
        'activity': 'Activity',
        'activity_suggestion': '(restaurant, shop,...)',
        'pos_terminal_location': 'POS terminal location',
        'pos_terminal_location_suggestion': 'address',
        'location_name': 'Location name',
        'location_name_suggestion': 'name of the shop, establishment',
        'contact_person': 'Contact person',
        'email': 'Email',
        'email_suggestion': 'where the statements will arrive',
        'phone_number': 'Phone number',
        'tax_number': 'TAX number',
        'registration_number': 'Registration number',
        'iban': 'IBAN',
        'expected_traffic': 'Expected traffic',
        'annual_gross_turnover': 'Annual gross turnover',
        'gross_card_turnover': 'Gross card turnover',
        'one_time_maximum_payment': 'One time maximum payment',
        'average_card_payment': 'Average card payment',
        'minimum_transaction_fee': 'Minimum transaction fee',
        'number_of_pos_terminals': 'Number of pos terminals',
        'owner_of_space_or_tenats': 'Owner of space / tenant',
        'owner_of_space': 'Owner of space',
        'space_rental': 'Space rental',
        'wifi_or_lte': 'WiFi / LTE',
        'wifi': 'WiFi',
        'lte': 'LTE',
        'purchase_of_terminal_or_rental': 'Purchase of terminal / Terminal rental',
        'purchase_of_terminal': 'Purchase of terminal',
        'terminal_rental': 'Terminal rental',
        'personal_card_image': 'Image of personal card',
        'name_of_terminal': 'Name of terminal',
        'company_data': 'Company data',
        'turnover': 'Turnover',
        'other': 'Other',
        'start_of_billing': 'Start of billing',
        'accounting_period': 'Accounting period',
        'daily': 'Daily',
        'weekly': 'Weekly',
        '14_daily': '14 daily',
        'monthly': 'Monthly',
        'term_terminal': 'Term terminal',
        'short_term': 'Short term',
        'long_term': 'Long term'
    },
    'equipment_procurement': {
        'equipment_procurement': 'Equipment procurement',
        'edit': 'Edit procurement',
        'do_you_really_want_to_cancel_purchased_equipment': 'Do you really want to cancel the purchased equipment'
    },
    'calendar': {
        'calendar': 'Calendar',
        'visit': 'Visit',
        'entry': 'Entry',
        'installation': 'Installation'
    },
    'business_unit': {
        'business_unit': 'Business unit',
        'unmovable_unit': 'Nepremični poslovni prostor',
        'movable_unit': 'A - Movable object (e.g. means of transport, mobile stand)',
        'permanent_location_unit': 'B - Facility at a permanent location (e.g. market stall, kiosk)',
        'device_unit': 'C - Single electronic device for issuing invoices',
        'business_unit_type': 'Business unit type',
        'business_unit_code': 'Business unit code',
        'address': {
            'address': 'Address',
            'street': 'Street',
            'house_number': 'House number',
            'house_number_additional': 'Additional',
            'postal_code': 'Postal Code',
            'city': 'Ciry',
            'cadastral': 'Cadastral',
            'cadastral_number': 'Cadastral number',
            'building_number': 'Building number',
            'building_section_number': 'Building section number',
            'community': 'Community'
        },
        'at_different_address': 'Business unit at different address',
        'business_unit_address': 'Business unit address',
        'business_unit_postal_code': 'Business unit postal code'
    },
    'attachment': {
        'attachment': 'Attachment | Attachments',
        'browse_attachment': 'Browse attachment'
    }
}
